import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';

import { CHILDREN_PROP_TYPES } from 'propTypes';
import ModalContainer from 'bento-ordering/base/containers/ModalContainer';
import StyledDialogContent from 'bento-ordering/base/ui_components/StyledDialogContent';

function Modal({ children, onClose, ariaLabel, role }) {
  return (
    <ModalContainer>
      <Dialog open={true} onClose={onClose} aria-label={ariaLabel} role={role}>
        <StyledDialogContent>{children}</StyledDialogContent>
      </Dialog>
    </ModalContainer>
  );
}

Modal.propTypes = {
  children: CHILDREN_PROP_TYPES.isRequired,
  onClose: PropTypes.func,
  ariaLabel: PropTypes.string,
  role: PropTypes.string
};

export default Modal;
